export default __webpack_public_path__ + "static/media/truck-03-thumbnail.fe30da34.jpg";